module.exports = {
	"my.topic": "My Topic",
  "reply.topic": "Replied Topic"
}


// WEBPACK FOOTER //
// ./src/pages/tags/i18n/locale.en.js